import { render, staticRenderFns } from "./InjectionNewComponent.vue?vue&type=template&id=70c37edb&scoped=true&"
import script from "./InjectionNewComponent.vue?vue&type=script&lang=js&"
export * from "./InjectionNewComponent.vue?vue&type=script&lang=js&"
import style0 from "./InjectionNewComponent.vue?vue&type=style&index=0&id=70c37edb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c37edb",
  null
  
)

export default component.exports